<label for="{{ id }}" class="sr-only">{{ label() }}</label>
<div class="relative flex grow items-stretch focus-within:z-10">
  <div class="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
    <wma-icon class="size-5 text-gray-400" name="search" />
  </div>
  <input
    id="{{ id }}"
    type="search"
    class="wma-input ps-10"
    [attr.placeholder]="placeholder()"
    [formControl]="search"
    (blur)="onTouched()"
  />
</div>
